var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Header", {
        class: _vm.$style.header,
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [_c("RouterLink", { attrs: { to: "/" } }, [_c("Logo")], 1)]
            },
            proxy: true,
          },
          {
            key: "center",
            fn: function () {
              return [
                !_vm.isTabletLandscapeUp
                  ? _c("h1", { class: _vm.$style.title }, [
                      _vm._v(" 捐款支持 "),
                    ])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "right",
            fn: function () {
              return [
                _c("nav", { class: _vm.$style.navHeader }, [
                  _c("ul", { class: _vm.$style.list }, [
                    _vm.isTabletLandscapeUp
                      ? _c(
                          "li",
                          { class: _vm.$style.item },
                          [
                            _c("MenuButton", [
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    border: "none",
                                    "text-decoration": "none",
                                  },
                                  attrs: {
                                    href: "https://www.teach4taiwan.org/",
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(" 回到 TFT 官網 ")]
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$route.name === "Home"
                      ? _c(
                          "li",
                          { class: _vm.$style.item },
                          [
                            _c(
                              "RouterLink",
                              {
                                class: _vm.$style.btnLink,
                                attrs: { to: "/search" },
                              },
                              [
                                _vm.isTabletLandscapeUp
                                  ? _c("MenuButton", [_vm._v(" 查詢捐款記錄 ")])
                                  : _c(
                                      "Button",
                                      {
                                        class: _vm.$style.navButton,
                                        staticStyle: { color: "#2f2f2f" },
                                        attrs: {
                                          small: "",
                                          transparent: "",
                                          grayscale: "",
                                        },
                                      },
                                      [
                                        _c("IconDonationSearch", {
                                          class: _vm.$style.navButton__icon,
                                          attrs: { width: "30" },
                                        }),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          "li",
                          { class: _vm.$style.item },
                          [
                            _vm.$route.name !== "period-result" &&
                            _vm.$route.name !== "single-result"
                              ? _c(
                                  "RouterLink",
                                  {
                                    class: _vm.$style.btnLink,
                                    attrs: { to: "/" },
                                  },
                                  [
                                    _vm.isTabletLandscapeUp
                                      ? _c("MenuButton", [
                                          _vm._v(" 返回捐款頁面 "),
                                        ])
                                      : _c(
                                          "Button",
                                          {
                                            class: _vm.$style.navButton,
                                            staticStyle: { color: "#2f2f2f" },
                                            attrs: {
                                              small: "",
                                              transparent: "",
                                              grayscale: "",
                                            },
                                          },
                                          [
                                            _c("IconBack", {
                                              class: _vm.$style.navButton__icon,
                                              attrs: { width: "27" },
                                            }),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                    _vm.isLoggedIn
                      ? _c(
                          "li",
                          { class: _vm.$style.item },
                          [
                            _c(
                              "Button",
                              {
                                attrs: { small: "", transparent: "" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleLogout.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v(" 登出 ")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { class: _vm.$style.container }, [_c("router-view")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }